import { match, matchPath } from 'react-router'
import { createSelector } from 'reselect'
import { PeopleMembersState } from 'src/app/PeopleMembers/redux/peopleMembers.reducer'
import { userIdOption } from 'src/components/UserDropdown/UserDropdown'
import {
  organizationInfoRouteProps,
  OrganizationsMatchParams,
} from 'src/navigation/routeProps'
import { RootState } from 'src/redux/createRootReducer'
import { selectMembersListModelsFromState } from 'src/redux/selectors/data/members.selectors'
import { selectLocationFromState } from 'src/redux/selectors/router.selectors'

export const selectNumberOfOrgMembersFromState = (state: RootState): number =>
  state.app.organizationInfo.orgMembers.totalItems || 0

export const selectFetchSuccessFromState = (state: RootState): boolean =>
  state.app.organizationInfo.fetchSuccess
export const selectFetchFailureFromState = (state: RootState): boolean =>
  state.app.organizationInfo.fetchFailure

export const selectPuttingOrganizationsFromState = (
  state: RootState,
): boolean => state.app.organizationInfo.puttingOrganizations

export const selectOrganizationsIdFromState = createSelector(
  [selectLocationFromState],
  (location) => {
    const mtch = matchPath<OrganizationsMatchParams>(
      location.pathname,
      organizationInfoRouteProps,
    ) as match<OrganizationsMatchParams>
    return mtch.params.id
  },
)

export const selectPeopleMembers = (state: RootState): PeopleMembersState =>
  state.app.organizationInfo.orgMembers

export const selectAllPeopleMembersFromState = createSelector(
  [selectMembersListModelsFromState],
  (users) => Object.keys(users).map((id: string) => userIdOption(users[id])),
)

export const selectPatchingOrganizationApproverFromState = (
  state: RootState,
): boolean => state.app.organizationInfo.patchingOrganizationApprover
